import { SxProps, Typography, Stack, tokens } from '@cast/design-system';

type Props = {
  icon: React.ReactNode;
  text: React.ReactNode;
  /** Optional secondary line under the primary checklist label. */
  description?: React.ReactNode;
  sx?: SxProps;
};

export const TrialListItemWithIcon = ({
  icon,
  text,
  description,
  sx,
}: Props) => {
  return (
    <Stack
      display="grid"
      gridTemplateColumns="16px auto"
      alignItems="flex-start"
      gap="8px"
      fontSize="16px"
      component="li"
      sx={sx}
    >
      {icon}
      <Stack gap={2}>
        <Typography variant="P14R" color={tokens.theme.fg.structural.primary}>
          {text}
        </Typography>
        {description ? (
          <Typography
            variant="P12R"
            color={tokens.theme.fg.structural.secondary}
          >
            {description}
          </Typography>
        ) : null}
      </Stack>
    </Stack>
  );
};
